export interface ToolEnvelope<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  timestamp: string;
  metadata?: {
    toolName?: string;
    toolCallId?: string;
    executionTimeMs?: number;
  };
}

export function isEnvelope(value: unknown): value is ToolEnvelope {
  return (
    typeof value === 'object' &&
    value !== null &&
    'success' in value &&
    'timestamp' in value
  );
}

export function unwrapEnvelope<T>(value: unknown): T | unknown {
  if (isEnvelope(value)) {
    if (value.success && value.data !== undefined) {
      return value.data as T;
    }

    // For errors, return undefined to trigger error handling
    return undefined;
  }

  return value;
}
